import React, {Component} from 'react';
import RaportyService from "../../RaportyService";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";
import acc from "accounting";
import DateAndTimeFormat from "../../../../utilities/DateAndTimeFormat";


export default class RozliczenieKursySzczegoloweContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dane:[]
        };
    }

    componentDidMount() {
        this.pobierzDaneDoRaportu(this.props.daty)
    }

    componentWillReceiveProps(nextprops) {
        if (Boolean(nextprops.daty)) {
            this.pobierzDaneDoRaportu(nextprops.daty)
        }
    }

    pobierzDaneDoRaportu(daty) {
        RaportyService.pobierzSzczegoloweRozliczenieKursow(daty[0],daty[1]).then(function (response) {
            let arr = Array.from(response.data,item=>{
                return{
                    ...item,
                    'imieNazwisko':item.imie+' '+item.nazwisko
                }
            })
            this.setState({dane:arr})
        }.bind(this))
    }

    render() {

        return (
            <div>
                <div>
                    <BootstrapTable data={this.state.dane}
                                    hover
                    >
                        <TableHeaderColumn dataField='idKu' isKey thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >ID kursu</TableHeaderColumn>
                        <TableHeaderColumn dataField='data' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Data</TableHeaderColumn>
                        <TableHeaderColumn dataField='godz_1p' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell,row)=>{return DateAndTimeFormat.formatHHMM(cell)}}
                        >Godzina</TableHeaderColumn>
                        <TableHeaderColumn dataField='imieNazwisko' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Kierowca</TableHeaderColumn>
                        <TableHeaderColumn dataField='nrRej' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Rej. pojazdu</TableHeaderColumn>
                        <TableHeaderColumn dataField='nazTr' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Trasa</TableHeaderColumn>
                        <TableHeaderColumn dataField='odcinek' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Odcinek</TableHeaderColumn>
                        <TableHeaderColumn dataField='lprzyst' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Ile przystanków</TableHeaderColumn>
                        <TableHeaderColumn dataField='dystans' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell,row)=>{return cell+' km'}}
                        >Dystans</TableHeaderColumn>
                        <TableHeaderColumn dataField='wartosc' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell,row)=>{return acc.formatMoney(cell)}}
                        >Wartość</TableHeaderColumn>
                    </BootstrapTable>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/raporty/RozliczenieKursow/Szczegolowe/RozliczenieKursySzczegoloweContainer.js